import { Table } from '@mui/material';
import { BaseTableProps } from './BaseTable.types';

/**
 * The base MUI Table used as an entry point and as separation for mocking.
 *
 * @param classes - {@link BaseTableProps.classes classes} description.
 * @param children - {@link BaseTableProps.children children} description.
 */
export const BaseTable = ({
    classes,
    children,
}: BaseTableProps) => {
    return (
        <Table
            classes={{
                ...classes,
            }}
        >
            {children}
        </Table>
    );
};